import hasVariantByIdInCartSelector from 'modules/cart/redux/selectors/has-variant-by-id-in-cart'
import logUtil from 'utils/log'
import hasReachedMaxFreeSamplesCountCartSelect from 'modules/cart/redux/selectors/has-reached-max-free-samples-count'
import getHasReachedMaxFreeSamplesCountMessageCartSelect from 'modules/cart/redux/selectors/get-has-reached-max-free-samples-count-message'
import { GIFT_CARD_VARIANT_IDS } from 'modules/gift/constants'
import getDiscountPercentageVariantSelector from 'modules/variant/redux/selectors/get-discount-percentage'
import updateShouldCreateDiscountsCartAction from 'modules/cart/redux/actions/update-should-create-discounts'
import logEventWithPrefixAnalyticsUtil from 'utils/analytics/log-event-with-prefix'
import getCompareAtPriceProductVariantUtil from 'modules/product-variant/utils/get-compare-at-price'
import isFullSizeVariantUtil from 'modules/variant/utils/is-full-size'
import handleAddCartAction from 'modules/cart/redux/actions/toggle-add-remove/actions/handle-add'
import handleRemoveProductCartAction from 'modules/cart/redux/actions/toggle-add-remove/actions/handle-remove'
import updateShouldEnablePSSDiscountCartUtil from 'modules/cart/utils/update-should-disable-pss-discount'
import getHasReachedMaxDeluxeSamplesCountMessageCartSelect from 'modules/cart/redux/selectors/get-has-reached-max-deluxe-samples-count-message'
import hasReachedMaxDeluxeSamplesCountCartSelect from 'modules/cart/redux/selectors/has-reached-max-deluxe-samples'
import beforeAddProductCartAction from 'modules/cart/redux/actions/toggle-add-remove/actions/before-add'

/**
 * @param {toggleAddRemoveProductCartActionProps} props
 * @returns {(function(*, *): Promise<undefined|{wasRemoved: *, wasAdded}>)|*}
 */
export default function toggleAddRemoveProductCartAction (props) {
  return async (dispatch, getState) => {
    const {
      variantId,
      onClickAdd,
      productVariant,
      subscriptionSellingPlanId,
      analyticEventPrefix,
      setIsLoading,
      shouldShowFullSizeConversion
    } = props

    const isInCart = hasVariantByIdInCartSelector(variantId)(getState())
    const isCurrentVariantAFullSize = isFullSizeVariantUtil(productVariant)
    const hasReachedMaxFreeSamplesCount = hasReachedMaxFreeSamplesCountCartSelect(getState())
    const hasReachedMaxFreeSamplesCountMessage = getHasReachedMaxFreeSamplesCountMessageCartSelect(getState())
    const hasReachedMaxDeluxeSamplesCount = hasReachedMaxDeluxeSamplesCountCartSelect(getState())
    const hasReachedMaxDeluxeSamplesCountMessage = getHasReachedMaxDeluxeSamplesCountMessageCartSelect(getState())
    const hasDiscount = !!getDiscountPercentageVariantSelector({ variantId })(getState())
    if (
      hasDiscount &&
      !getCompareAtPriceProductVariantUtil({ variant: productVariant })
    ) {
      dispatch(updateShouldCreateDiscountsCartAction(true))
      updateShouldEnablePSSDiscountCartUtil()
    }

    const debugProps = {
      props,
      isInCart,
      hasReachedMaxFreeSamplesCountMessage,
      hasReachedMaxFreeSamplesCount,
      hasReachedMaxDeluxeSamplesCount,
      hasReachedMaxDeluxeSamplesCountMessage,
      isCurrentVariantAFullSize,
      analyticEventPrefix
      // hasSampled
    }
    logUtil('toggleAddRemoveProductCartAction').debug('debugProps=', debugProps)

    const logEvent = (event) => {
      const analyticsEventProps = {}
      if (productVariant?.aov_lock) {
        analyticsEventProps.aov_lock = productVariant.aov_lock
      }

      return logEventWithPrefixAnalyticsUtil(analyticEventPrefix, event, analyticsEventProps)
    }

    // if (
    //   hasSampled &&
    //   isSampleVariantUtil(productVariant)
    // ) {
    //   dispatch(updateCurrentToastAction(YOU_VE_ALREADY_SAMPLED_THIS_ITEM))
    //   return {
    //     error: YOU_VE_ALREADY_SAMPLED_THIS_ITEM
    //   }
    // }

    const isGiftCard = GIFT_CARD_VARIANT_IDS.includes(variantId)
    const res = isInCart
      ? null
      : dispatch(beforeAddProductCartAction(props))
    if (res) {
      return
    }

    const handleRemove = async () => {
      return (
        dispatch(
          handleRemoveProductCartAction({
            logEvent,
            variantId,
            isGiftCard,
            productVariant,
            shouldShowFullSizeConversion
          })
        )
      )
    }

    const handleAdd = async () => {
      return (
        dispatch(
          handleAddCartAction({
            logEvent,
            onClickAdd,
            subscriptionSellingPlanId,
            variantId,
            isGiftCard,
            productVariant,
            shouldShowFullSizeConversion
          })
        )
      )
    }

    try {
      setIsLoading?.(true)
      await (isInCart ? handleRemove() : handleAdd())
      setIsLoading?.(false)
      logUtil('toggleAddRemoveProductCartAction').debug('[done]')

      return {
        wasAdded: !isInCart,
        wasRemoved: isInCart
      }
    } catch (error) {
      logUtil('toggleAddRemoveProductCartAction').error('error=', error)
    }
  }
}
